<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint0)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint1)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint2)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint3)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint4)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint5)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint6)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint7)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint8)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint9)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint10)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint11)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint12)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint13)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint14)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint15)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint16)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint17)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint18)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint19)"
    />
    <path
      d="M13.9534 2.80836L15.6057 6.27319C15.8616 6.78769 16.3282 7.14945 16.87 7.22984L20.5656 7.7524C22.4696 8.03376 23.1877 10.0781 21.7112 11.5664L19.1213 14.2383C18.6999 14.6563 18.5042 15.2753 18.6096 15.8782L19.1917 19.6758C19.5228 21.6453 17.8639 23.0427 16.1856 22.1423L12.784 20.3335C12.3099 20.0843 11.753 20.0843 11.2789 20.3335L7.87729 22.1423C6.19907 23.0346 4.43774 21.6797 4.92993 19.6289L5.50415 15.9141C5.60951 15.3111 5.41384 14.6921 4.9924 14.2741L2.35178 11.5078C0.863522 10.0371 1.59335 8.03376 3.49735 7.7524L7.057 7.22984C7.59884 7.14945 8.22065 6.79573 8.46899 6.27319L10.1547 2.80836C11.0127 1.06388 13.103 1.06388 13.9534 2.80836Z"
      fill="url(#rating-star-paint20)"
    />
    <defs>
      <radialGradient
        id="rating-star-paint0"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-10.2082 10.9705 -10.9186 -10.0358 18.4065 6.72657)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F7C334" />
        <stop offset="1"
              stop-color="#FAC832"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint1"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.0289 11.9608) rotate(90) scale(10.4608 10.471)"
      >
        <stop stop-color="#DDBA38" />
        <stop offset="1"
              stop-color="#DDBA38"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint2"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.295 7.56112) rotate(74.0546) scale(1.69886 5.66955)"
      >
        <stop stop-color="#DDBA38" />
        <stop offset="1"
              stop-color="#DDBA38"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint3"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.55786 8.64039) rotate(16.0828) scale(2.94827 2.95115)"
      >
        <stop stop-color="#B5953A" />
        <stop offset="1"
              stop-color="#B5953A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint4"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.66597 23.1085) rotate(-58.4957) scale(2.12117 2.12324)"
      >
        <stop stop-color="#C47E42" />
        <stop offset="1"
              stop-color="#C47E42"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint5"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.2926 8.75707) rotate(150.751) scale(1.6716 2.19796)"
      >
        <stop stop-color="#FFF246" />
        <stop offset="1"
              stop-color="#FFF246"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint6"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5 22.125) rotate(21.8014) scale(2.01944 1.00972)"
      >
        <stop stop-color="#FFF246" />
        <stop offset="1"
              stop-color="#FFF246"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint7"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.5 6.75) rotate(-45) scale(6.89429)"
      >
        <stop offset="0.113127"
              stop-color="#FFF249"
        />
        <stop offset="0.298269"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint8"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.125 17.25) rotate(-18.435) scale(4.74342 9.89442)"
      >
        <stop offset="0.0592265"
              stop-color="#FFF249"
        />
        <stop offset="0.39519"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint9"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5 7.875) rotate(3.57634) scale(6.01171 1.6216)"
      >
        <stop offset="0.26571"
              stop-color="#FFF249"
        />
        <stop offset="0.807393"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint10"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.25 3) rotate(74.4759) scale(7.00558 1.88969)"
      >
        <stop offset="0.26571"
              stop-color="#FFF249"
        />
        <stop offset="0.738695"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint11"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5 21) rotate(-98.5308) scale(7.5839 2.04569)"
      >
        <stop offset="0.26571"
              stop-color="#FFF249"
        />
        <stop offset="0.738695"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint12"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.5 2.625) rotate(116.565) scale(7.54673 1.92861)"
      >
        <stop offset="0.0888889"
              stop-color="#B58B32"
        />
        <stop offset="0.933333"
              stop-color="#B58B32"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint13"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1.875 10.875) rotate(48.0128) scale(10.0902 3.58523)"
      >
        <stop offset="0.121202"
              stop-color="#B58B32"
        />
        <stop offset="0.758978"
              stop-color="#B58B32"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint14"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.25 18) rotate(100.62) scale(6.10456 2.51957)"
      >
        <stop offset="0.121202"
              stop-color="#B58B32"
        />
        <stop offset="0.863208"
              stop-color="#B58B32"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint15"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.375 21.375) rotate(153.435) scale(5.86968 2.83002)"
      >
        <stop offset="0.121202"
              stop-color="#C6913B"
        />
        <stop offset="0.957143"
              stop-color="#C6913B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint16"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.625 21) rotate(28.3007) scale(5.53681 2.01281)"
      >
        <stop offset="0.121202"
              stop-color="#B48A32"
        />
        <stop offset="0.738695"
              stop-color="#B48A32"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint17"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.875 21.75) rotate(119.745) scale(3.02335 3.79372)"
      >
        <stop offset="0.144231"
              stop-color="#B58B32"
        />
        <stop offset="0.738695"
              stop-color="#B58B32"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint18"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.125 8.25) rotate(-29.7449) scale(3.02335 3.50592)"
      >
        <stop offset="0.0027979"
              stop-color="#FFF249"
        />
        <stop offset="0.686538"
              stop-color="#FFF249"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint19"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.625 12.375) rotate(45) scale(2.65165 6.45616)"
      >
        <stop offset="0.125"
              stop-color="#E0AE33"
        />
        <stop offset="0.95"
              stop-color="#E0AE33"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="rating-star-paint20"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21 12.75) rotate(45) scale(2.12132 7.26235)"
      >
        <stop offset="0.234947"
              stop-color="#E5BD42"
        />
        <stop offset="0.693004"
              stop-color="#E5BD42"
              stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
